import { useSyncAccountsWhenRegionReady } from "Hooks/useSyncAccountsWhenRegionReady";
import { useGetMerchantAppProductsQuery } from "Api/Queries/Merchants/useGetMerchantAppProductsQuery";
import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";
import { LimitedAccountPopup } from "Components/Dashboard/LimitedAccountPopup";
import { TransactionsComponent } from "Components/Dashboard/TransactionsComponent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { MerchantPaymentComponent } from "Components/Merchant/Payment/MerchantPaymentComponent";
import { OrbitLDashboardModule } from "Components/Merchant/OrbitL/OrbitLDashboardModule";
import { isComgateProductCode } from "Components/Shared/Merchant/Products/AppProducts/constants";
import { BlDivider } from "Components/Shared/BlDivider";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Titles;

export const MerchantOverviewPage = () => {
  const { t } = useResource();
  useSyncAccountsWhenRegionReady();
  const { data: merchant } = useGetMerchantQuery();
  const { data: appProducts } = useGetMerchantAppProductsQuery();

  const hasComgateProduct = appProducts?.some((ap) =>
    isComgateProductCode(ap.productDto.code),
  );

  return (
    <AuthenticatedLayout
      title={t(RESOURCES.MerchantOverview)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null, // "root" page, nowhere higher to go
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <MerchantPaymentComponent />
          <LimitedAccountPopup />
          {hasComgateProduct && merchant?.publicID && (
            <>
              <BlDivider />
              <OrbitLDashboardModule merchantPublicID={merchant.publicID} />
            </>
          )}
          <BlDivider />
          <TransactionsComponent />
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default MerchantOverviewPage;
